import styled from 'styled-components';

export const InfographicImg = styled.section`
  width: 100%;
  position: relative;
  aspect-ratio: 16/16;
  background: url(https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp)
    center center / contain;

  div,
  span {
    position: unset !important;
  }

  img {
    object-fit: contain;
    width: 100% !important;
    position: relative !important;
    height: unset !important;
  }
`;
